import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import SetLinkedSoftAccountsPage from './SetLinkedSoftAccountsPage';
import {
    accountStatusCheck as accountStatusCheckAction,
    signUpUser as signUpUserAction,
    socialLogInUser as socialLogInUserAction,
    socialLogInUserNotAuthorized as socialLogInUserNotAuthorizedAction,
    socialSignUpUser as socialSignUpUserAction,
    linkAccountsOnLogin as linkAccountsOnLoginAction,
    moveBack as moveBackAction,
    sendResetPasswordEmail as sendResetPasswordEmailAction,
    clearAuthNotification as clearAuthNotificationAction,
    forceStld as forceStldAction,
    trackSocialProviderClick as trackSocialProviderClickAction,
    trackEmailMismatchAction,
    trackEmailConfirmationInput as trackEmailConfirmationAction,
    trackLoginInsteadClick as trackLoginInsteadAction,
    onSkipSocialLinks,
} from '../../actions/auth';

import {
    trackSIWA_LookUpSuccessWithEmail,
    trackSIWA_LookUpSuccessWithHiddenEmail,
} from '../../actions/gaTracking';

const _mapStateToProps = ({ authentication, form }) => ({
    form,
    email: authentication.email,
    socialData: authentication.socialData,
    socialAuthenticationData: authentication.socialAuthenticationData,
    locale: authentication.locale,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    fp: authentication.fp,
    socialSSOSettings: authentication.socialSSOSettings,
    authNotificationOptions: authentication.authNotificationOptions,
    linkedAccountSuccessUrl: authentication.linkedAccountSuccessUrl,
    authTypeSetting: authentication.authTypeSetting,
    stld: authentication.stld,
    shouldIncludeEmailConfirmation:
        authentication.shouldIncludeEmailConfirmation,
    disableRecaptcha3: authentication.disableRecaptcha3,
});

const _mapDispatchToProps = {
    onAccountStatusCheck: accountStatusCheckAction,
    onSignUpUser: signUpUserAction,
    onSocialLogInUser: socialLogInUserAction,
    onSocialLogInUserNotAuthorized: socialLogInUserNotAuthorizedAction,
    onSocialSignUpUser: socialSignUpUserAction,
    onLinkAccountsOnLogin: linkAccountsOnLoginAction,
    moveBack: moveBackAction,
    onLinkedAccountsCreatePassword: sendResetPasswordEmailAction,
    handleForgotPassword: sendResetPasswordEmailAction,
    clearAuthNotification: clearAuthNotificationAction,
    onForceStld: forceStldAction,
    onSocialProviderClick: trackSocialProviderClickAction,
    trackEmailConfirmationEdit: trackEmailConfirmationAction,
    trackEmailMismatchShowed: trackEmailMismatchAction,
    onLoginInsteadClick: trackLoginInsteadAction,
    onSkipSocialLinks,
    trackSIWA_LookUpSuccessWithEmail,
    trackSIWA_LookUpSuccessWithHiddenEmail,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SetLinkedSoftAccountsPage),
);
